/* =====================================================================
   kd-desktop.js — Correctifs structurels DESKTOP Kanadeal (v2, 04/07/2026, Claude)
   ---------------------------------------------------------------------
   ⚠️ GARDE ABSOLUE : ne s'exécute QUE si le viewport initial est ≥ 750px.
   Sur mobile ce script ne fait STRICTEMENT RIEN (return immédiat).
   v2 : SUPPRESSION de la fusion des sections « avantages » — le thème gère
   nativement la visibilité par appareil (pmWTQT/ckpUmL = mobile only,
   HJaYae/3fGPpf = desktop only avec déjà 4 tuiles). La fusion créait des
   doublons. Le stylage 4 colonnes est fait en pur CSS dans kd-desktop.css.
   Rôles restants :
   1. Replier les sections VIDES (bandes fantômes, ~12 sur fiche produit)
   2. Injecter le strip « Nos univers » (chips catégories) sur l'accueil
   3. Nettoyer les badges cassés (« 14%% CBD » → « 14% CBD »), défensif
   ===================================================================== */
(function () {
  if (!window.matchMedia || !window.matchMedia('(min-width: 750px)').matches) return;

  var CDN = 'https://cdn.shopify.com/s/files/1/0974/3286/3046/files';
  var CAT_IMAGES = {
    'fleurs-cbd':   CDN + '/kd-cat-fleurs.jpg?v=1782156359',
    'pre-rolls-cbd':CDN + '/kd-cat-prerolls.jpg?v=1782156359',
    'resines-cbd':  CDN + '/kd-cat-resines.jpg?v=1782156360',
    'zombie-cbd':   CDN + '/kd-cat-zombie.jpg?v=1782156359'
  };

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ---------- 1. Replier les sections vides ---------- */
  function collapseEmpties() {
    $$('.shopify-section.section-wrapper').forEach(function (sec) {
      if (sec.classList.contains('kd-desk-hidden')) return;
      if (sec.classList.contains('hero-wrapper')) return;
      if (sec.querySelector('img, svg, video, iframe, form, input, .background-image-container, [class*="jdgm"], .kd-reviews, .kd-home-fidelite')) return;
      var txt = (sec.textContent || '').replace(/\s+/g, '');
      if (txt === '') sec.classList.add('kd-desk-hidden');
    });
  }

  /* ---------- 2. Strip « Nos univers » sur l'accueil ---------- */
  function gridIcon() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>';
  }
  function catsStripHtml(compact) {
    var cats = window.KD_SHOP_CATS;
    if (!cats || !cats.length) return '';
    var cur = window.KD_CUR_CAT || '';
    var html = compact ? '' : '<p class="kd-desk-cats__title">Nos univers CBD</p>';
    html += '<div class="kd-desk-cats__row">';
    cats.forEach(function (c) {
      var circle;
      if (c.h === 'all') {
        circle = '<span class="kd-desk-cat__circle kd-desk-cat__circle--all">' + gridIcon() + '</span>';
      } else {
        var img = CAT_IMAGES[c.h] || c.img || '';
        circle = '<span class="kd-desk-cat__circle">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="160" height="160">' : gridIcon()) + '</span>';
      }
      var active = (c.h === cur) ? ' kd-desk-cat--active' : '';
      html += '<a class="kd-desk-cat' + active + '" href="' + c.u + '">' + circle + '<span class="kd-desk-cat__label">' + c.t + '</span></a>';
    });
    html += '</div>';
    return html;
  }
  function buildCatsStrip() {
    /* accueil : strip complet tout en haut */
    var main = $('main[data-template="index"]');
    if (main && !$('.kd-desk-cats', main)) {
      var inner = catsStripHtml(false);
      if (inner) {
        var strip = document.createElement('section');
        strip.className = 'kd-desk-cats';
        strip.setAttribute('aria-label', 'Nos univers CBD');
        strip.innerHTML = inner;
        main.insertBefore(strip, main.firstElementChild);
      }
    }
    /* pages collection : strip compact juste au-dessus de la grille produits
       (équivalent desktop des pastilles du drawer Filtrer mobile) */
    var collMain = $('main[data-template="collection"]');
    if (collMain && !$('.kd-desk-cats', collMain)) {
      var gridSection = $('div[id^="shopify-section-template--"][id$="__main"]', collMain);
      var inner2 = catsStripHtml(true);
      if (gridSection && inner2) {
        var strip2 = document.createElement('section');
        strip2.className = 'kd-desk-cats kd-desk-cats--compact';
        strip2.setAttribute('aria-label', 'Nos univers CBD');
        strip2.innerHTML = inner2;
        gridSection.parentNode.insertBefore(strip2, gridSection);
      }
    }
  }

  /* ---------- 2ter. Pilule « Mes points » dans le header (équivalent
     desktop du bandeau fidélité du menu burger mobile) ---------- */
  function buildPointsPill() {
    if ($('.kd-desk-points')) return;
    var acc = $('shopify-account');
    var host = $('.header-actions') || (acc && acc.parentElement);
    if (!host) return;
    var m = window.KD_MEMBER || {};
    var label = m.loggedIn ? 'Mes points' : 'Fidélité';
    var pts = m.loggedIn ? '<b>' + (parseInt(m.points, 10) || 0) + ' pts</b>' : '';
    var a = document.createElement('a');
    a.className = 'kd-desk-points';
    a.href = '/pages/mes-points';
    a.innerHTML = '<span aria-hidden="true">⚡</span><span>' + label + '</span>' + pts;
    host.insertBefore(a, host.firstElementChild);
  }

  /* ---------- 2bis. Mega-menu : vignettes produits dans les déroulants ----------
     Au premier survol du header, chaque lien produit des déroulants reçoit
     sa photo (JSON public /products/{handle}.js). Une seule passe, silencieux
     en cas d'échec. Le style vit dans kd-desktop.css (.kd-mm-thumb). */
  var mmDone = false;
  function enhanceMegaMenus() {
    if (mmDone) return;
    var links = $$('.menu-list__submenu .mega-menu__link[href^="/products/"]');
    if (!links.length) return;
    mmDone = true;
    links.forEach(function (a) {
      if (a.classList.contains('kd-mm-rich')) return;
      var handle = a.getAttribute('href').split('?')[0].replace(/\/$/, '').split('/').pop();
      if (!handle) return;
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p || !p.featured_image) return;
          var url = p.featured_image;
          url += (url.indexOf('?') === -1 ? '?' : '&') + 'width=96';
          var img = document.createElement('img');
          img.className = 'kd-mm-thumb';
          img.src = url;
          img.alt = '';
          img.loading = 'lazy';
          img.width = 46; img.height = 46;
          a.insertBefore(img, a.firstChild);
          a.classList.add('kd-mm-rich');
        })
        .catch(function () { /* silencieux */ });
    });
  }
  function armMegaMenus() {
    var header = $('header-component.header') || $('.header-section');
    if (!header) return;
    header.addEventListener('pointerenter', enhanceMegaMenus, { once: true });
    /* filet de sécurité : si jamais pointerenter ne vient pas (clavier) */
    setTimeout(enhanceMegaMenus, 6000);
  }

  /* ---------- 3. Badges : « 14%% CBD » → « 14% CBD » (défensif) ---------- */
  function fixBadgeText() {
    $$('.product-card__cbd-overlay-badge').forEach(function (b) {
      if (b.textContent.indexOf('%%') !== -1) {
        b.textContent = b.textContent.replace(/%{2,}/g, '%');
      }
    });
  }

  /* ---------- boucle d'init (idempotente, quelques retries) ---------- */
  /* ---------- 4. Recherche sans résultat : CTA retour boutique ---------- */
  function buildSearchCta() {
    var box = $('main[data-template="search"] .search-results__no-results');
    if (!box || $('.kd-search-cta', box)) return;
    var a = document.createElement('a');
    a.className = 'kd-search-cta';
    a.href = '/collections/all';
    a.textContent = 'Voir tous les produits →';
    box.appendChild(a);
  }

  function run() {
    collapseEmpties();
    buildCatsStrip();
    buildPointsPill();
    buildSearchCta();
    fixBadgeText();
  }
  function init() {
    run();
    var n = 0;
    var iv = setInterval(function () {
      n++;
      run();
      if (n >= 6) clearInterval(iv); /* ~3s de retries (contenus injectés tard) */
    }, 500);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); armMegaMenus(); });
  } else {
    init();
    armMegaMenus();
  }
  window.addEventListener('load', run);
})();
